const staticContent = ['E-Mail', 'telefonisch', 'Soziale Medien', 'WhatsApp', 'egal'];
module.exports = staticContent;
